<div #targetDiv class="row position-relative h-100">
  <ng-container *ngIf="isMobile; else notMobile">
    <ng-container *ngTemplateOutlet="splitter1"> </ng-container>

    <ng-container *ngTemplateOutlet="splitter2"> </ng-container>
  </ng-container>

  <ng-template #notMobile>
    <p-splitter
      [style]="{ height: '100%', border: 'none', width: '100%' }"
      [panelSizes]="dynamicPanelSizes"
      styleClass="mb-5"
      (onResizeEnd)="onSplitterResize($event)"
      panelStyleClass="overflow-x-auto"
      [minSizes]="[30, 0]">
      <ng-template pTemplate>
        <ng-container *ngTemplateOutlet="splitter1"></ng-container>
      </ng-template>
      <ng-template pTemplate>
        <ng-container *ngTemplateOutlet="splitter2"></ng-container>
      </ng-template>
    </p-splitter>
  </ng-template>
</div>

<ng-template #splitter1>
  <div class="col-lg-12">
    <div class="property-details p-0 border-0 add-main-padding">
      <div class="tabs-wrap">
        <div>
          <form class="tab-content form UserForm_tabs" [formGroup]="UserForm" #contactFormElement>
            <div class="tab-content" id="pills-tabContent">
              <div class="tab-pane fade show active">
                <div class="position-relative">
                  <div class="{{ isMobile ? 'd-block' : 'd-flex' }} align-items-start justify-content-between">
                    <div class="dfx">
                      <div class="profile-section d-flex align-items-center">
                        <div class="profile-thumb position-relative {{ isMobile ? '' : 'h-90' }}">
                          <div class="user-thumbnail-placeholder">
                            <span
                              class="ng-star-inserted text-uppercase"
                              *ngIf="!UserForm?.get('photo')?.value && (UserForm.get('first_name').value || UserForm.get('last_name').value)">
                              {{
                                (UserForm.get('first_name')?.value ? UserForm.get('first_name')?.value.charAt(0) : '') +
                                  (UserForm.get('last_name')?.value ? UserForm.get('last_name')?.value.charAt(0) : '')
                              }}
                            </span>
                            <span
                              class="ng-star-inserted"
                              *ngIf="!UserForm?.get('photo')?.value && !UserForm.get('first_name').value && !UserForm.get('last_name').value">
                              D1
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-block w-xs-100">
                      <div class="dfl">
                        <div class="ml-2 cs-width">
                          <label for="type">Contact Type</label>
                          <div class="form-group mb-0">
                            <ng-select
                              bindLabel="tag_name"
                              bindValue="value"
                              [items]="addType"
                              [multiple]="false"
                              [searchable]="false"
                              placeholder="Select Type"
                              formControlName="type"
                              class="primary-taged"
                              [readonly]="isPrivate"
                              (change)="contactTypeChanged()">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="ml-2 cs-width" *ngIf="UserForm.controls['type'].value === 'Company'">
                          <label for="type">Type</label>
                          <div class="form-group mb-0">
                            <ng-select
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [items]="companyType"
                              [multiple]="false"
                              [searchable]="false"
                              placeholder="Select Company Type"
                              formControlName="company_type"
                              class="primary-taged"
                              [readonly]="isPrivate"
                              [ngClass]="{ '_input-error': submitted && f.company_type.errors }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="ml-2 cs-width" *ngIf="UserForm.controls['type'].value === 'Contact'">
                          <label for="type">Type</label>
                          <div class="form-group mb-0">
                            <ng-select
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [items]="contactType"
                              [multiple]="false"
                              [searchable]="false"
                              placeholder="Select Contact Type"
                              formControlName="contact_type"
                              class="primary-taged"
                              [readonly]="isPrivate"
                              [ngClass]="{ '_input-error': submitted && f.contact_type.errors }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3 d-flex align-items-center justify-content-between">
                    <div>
                      <p class="f-20" *ngIf="UserForm.get('type').value && lmService?.contact_show_div">
                        {{
                          UserForm.get('type').value === 'Company'
                            ? UserForm.get('company_name').value
                            : UserForm.get('first_name').value + ' ' + UserForm.get('last_name').value
                        }}
                      </p>
                    </div>
                    <div *ngIf="lmService?.contact_show_div == 'add_contact'">
                      <button
                        type="submit"
                        class="_outline-btn ml-auto mr-2 btn-sm"
                        [disabled]="isPrivate"
                        [class.disabled]="submittedBtn"
                        (click)="createContact(false, 'onlyCreate')">
                        Save
                      </button>
                      <ng-container *ngIf="lmService.tab_levels?.length === 1 && lmService?.contact_show_div == 'add_contact'">
                        <button
                          type="submit"
                          class="_primary-btn ml-auto btn-sm"
                          [disabled]="isPrivate"
                          [class.disabled]="submittedBtn"
                          (click)="createContact(false, 'create')">
                          Save & Close
                        </button>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <app-collapse-box [headingClassName]="'f-14'" [heading]="'Contact Details'" [background]="true">
                  <div class="property-details mt-2 p-0 border-0">
                    <div class="pb-2 pt-2" *ngIf="numOfNotValidFields > 0">
                      <p class="form-error font-weight-bold cursor-pointer" (click)="notDisplayRequiredMessage = false">
                        You have {{ numOfNotValidFields }} notifications. Select to view.
                      </p>
                      <div class="error-message" [ngClass]="{ 'd-none': notDisplayRequiredMessage }">
                        <ul>
                          <li
                            class="pb-1 cursor-pointer"
                            *ngFor="let message of requiredErrorMessages"
                            (click)="ActivateTabIndexByError(message.field)">
                            {{ message?.message | capitalizephrase }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="row">
                      <ng-container *ngIf="UserForm.controls['type'].value !== 'Company'; else has_company">
                        <div class="col-sm-2 pr-0">
                          <div class="form-group">
                            <label for="lastname">Title</label>
                            <ng-select
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [items]="addTile"
                              [multiple]="false"
                              [searchable]="false"
                              [clearable]="false"
                              placeholder="Select"
                              formControlName="add_title"
                              [ngClass]="{ 'is-invalid': submitted && f.add_title.errors }"
                              [readonly]="isPrivate">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-5 pr-0">
                          <div class="form-group">
                            <label for="firstName">First Name<span title="Required">*</span></label>
                            <input
                              type="text"
                              class="site-input"
                              formControlName="first_name"
                              [readonly]="isPrivate"
                              [ngClass]="{
                                '_input-error': submitted && f.first_name.errors?.['required'],
                              }" />
                            <div *ngIf="submitted && f.first_name.invalid" class="ml-2 mt-1">
                              <p *ngIf="f.first_name.errors?.['required']" class="text-danger f-10">First name is required</p>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-5">
                          <div class="form-group">
                            <label for="firstname">Last Name</label>
                            <input type="text" class="site-input" formControlName="last_name" [readonly]="isPrivate" />
                          </div>
                        </div>
                        <div
                          class="{{ dynamicPanelSizes[0] <= '35' ? 'col-sm-12' : 'col-sm-6 pr-0' }}"
                          *ngIf="UserForm.controls['contact_type'].value?.toLowerCase() === 'agent'">
                          <div class="form-group">
                            <label for="position">Position</label>
                            <ng-select
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [items]="companyRole"
                              [multiple]="false"
                              [searchable]="true"
                              [clearable]="true"
                              placeholder="Select Position"
                              formControlName="position"
                              class="primary-taged"
                              [readonly]="isPrivate">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div
                          class="{{ dynamicPanelSizes[0] <= '35' ? 'col-sm-12' : 'col-sm-6 pr-0' }}"
                          *ngIf="UserForm.controls['contact_type'].value?.toLowerCase() === 'agent'">
                          <div class="form-group">
                            <label for="wechat">WeChat</label>
                            <input type="text" class="site-input" formControlName="wechat" [readonly]="isPrivate" />
                          </div>
                        </div>
                        <div class="{{ dynamicPanelSizes[0] <= '35' ? 'col-sm-12' : 'col-sm-6 pr-0' }}">
                          <div class="form-group">
                            <label for="firstname">Preferred Name</label>
                            <input
                              type="text"
                              class="site-input"
                              formControlName="nick_name"
                              [readonly]="isPrivate"
                              [ngClass]="{ 'is-invalid': submitted && f.nick_name.errors }" />
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #has_company>
                        <div class="col-12 col-xl-12" *ngIf="UserForm.controls['type'].value === 'Company'">
                          <div class="form-group">
                            <label class="mb-1">Company Name <span title="Required">*</span></label>
                            <input
                              type="text"
                              class="site-input"
                              formControlName="company_name"
                              [readonly]="isPrivate"
                              [ngClass]="{
                                '_input-error': submitted && f.company_name.errors?.['required'],
                              }" />
                            <div *ngIf="submitted && f.company_name.invalid" class="ml-2 mt-1">
                              <p *ngIf="f.company_name.errors?.['required']" class="text-danger f-10">Company name is required</p>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                      <div class="{{ dynamicPanelSizes[0] <= '35' ? 'col-sm-12' : 'col-sm-6' }}">
                        <div class="form-group mb-2">
                          <label for="firstname">Preferred Contact Method</label>
                          <re-multiSelect
                            [options]="preferred_contact_method"
                            formControlName="preferred_contact_method"
                            optionLabel="tag_name"
                            optionValue="tag_name"
                            class="multiselect"
                            placeholder="Select Contact Method"></re-multiSelect>
                        </div>
                      </div>
                      <div class="{{ dynamicPanelSizes[0] <= '35' ? 'col-sm-12' : 'col-sm-6' }}" *ngIf="UserForm.controls['type'].value == 'Company'">
                        <div class="form-group">
                          <label>Phone</label>
                          <input type="text" class="site-input" formControlName="telephone_no" [readonly]="isPrivate" />
                        </div>
                      </div>
                      <div class="{{ dynamicPanelSizes[0] <= '35' ? 'w-100' : 'col-sm-12 col-md-12 col-lg-6 col-xs-12 ' }}">
                        <div class="{{ dynamicPanelSizes[0] <= '35' ? 'w-100 d-flex' : 'row' }}">
                          <div class="{{ dynamicPanelSizes[0] <= '35' ? 'w-100 pr-2' : 'col-12 py-0' }} email__">
                            <div class="form-group mb-2">
                              <label for="email">Email <span title="Required">*</span></label>
                              <input
                                type="email"
                                class="site-input"
                                formControlName="email"
                                [readonly]="isPrivate"
                                [ngClass]="{
                                  '_input-error': submitted && (f.email.errors?.['required'] || f.email.errors?.['email']),
                                }" />
                              <div *ngIf="submitted && f.email.invalid" class="ml-2 mt-1">
                                <p *ngIf="f.email.errors?.['required']" class="text-danger f-10">Email is required</p>
                                <p *ngIf="f.email.errors?.['email']" class="text-danger f-10">Invalid email format</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="{{ dynamicPanelSizes[0] <= '35' ? 'w-100' : 'col-sm-12 col-md-12 col-lg-6 col-xs-12' }}"
                        *ngIf="UserForm.controls['type'].value !== 'Company'">
                        <div class="{{ isMobile ? 'mob__responsive' : 'd-flex' }}">
                          <label *ngIf="isMobile">Phone</label>
                          <div class="mb-2 form-group w-100">
                            <label *ngIf="!isMobile">Phone</label>
                            <input
                              type="text"
                              class="site-input {{ isMobile ? 'mt-3' : '' }}"
                              formControlName="mobile_no"
                              [readonly]="isPrivate"
                              appMobileMask
                              placeholder="0000 000 000"
                              [ngClass]="{ 'is-invalid': submitted && f.mobile_no.errors }" />
                            <div *ngIf="submitted && f.mobile_no.invalid" class="ml-2 mt-1">
                              <p *ngIf="f.mobile_no.errors?.['required']" class="text-danger f-10">Phone is required</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="{{ dynamicPanelSizes[0] <= '35' ? 'w-100' : 'col-sm-12 col-md-12 col-lg-6 col-xs-12' }}"
                        *ngIf="UserForm.controls['type'].value == 'Company'">
                        <div>
                          <label>Website</label>
                          <input type="text" class="site-input {{ isMobile ? 'mt-3' : '' }}" formControlName="website" [readonly]="isPrivate" />
                        </div>
                      </div>
                      <div class="{{ dynamicPanelSizes[0] <= '35' ? 'col-sm-12' : 'col-sm-6' }}">
                        <div class="form-group mb-2">
                          <label for="sub_office_id">Sub Office</label>
                          <ng-select
                            [items]="subOfficeList"
                            bindLabel="office_name"
                            bindValue="_id"
                            [searchable]="true"
                            [clearable]="true"
                            placeholder="Select Sub Office"
                            formControlName="sub_office_id"
                            [readonly]="isPrivate"></ng-select>
                        </div>
                      </div>
                      <div class="col-12 mt-2">
                        <app-contact-alternative-info [items]="alternativeInfo" [isReadonly]="isPrivate"></app-contact-alternative-info>
                      </div>
                    </div>
                  </div>
                </app-collapse-box>
                <div class="mt-3">
                  <app-collapse-box [headingClassName]="'f-14'" [heading]="'Company'">
                    <div class="property-details mt-2 p-0 border-0">
                      <div class="row">
                        <div *ngIf="UserForm.controls['type'].value !== 'Company'">
                          <div class="row align-items-end">
                            <div class="col-12 grio">
                              <label for="">
                                <re-multiselect
                                  [module]="'contacts'"
                                  [type]="'Company'"
                                  [placeholder]="'Select'"
                                  [truncate]="25"
                                  [isMultiple]="false"
                                  [isCreateNew]="false"
                                  [isClear]="true"
                                  [isEmail]="true"
                                  [isFullObject]="true"
                                  [escapeOverflow]="true"
                                  (createNew)="openRightModal(null, 'add_contact')"
                                  [selected_ids]="companies"
                                  (onUpdate)="selectCompany($event)"
                                  [style]="{ width: '100%' }"></re-multiselect>
                              </label>
                              <button class="_outline-btn" (click)="attachCompany()" [class.disabled]="loading" [disabled]="isPrivate">
                                Associate
                              </button>
                            </div>
                          </div>
                          <p class="f-10 mt-1 ml-3">When creating a new Company, press Save and not Save and Close</p>
                          <ng-container *ngIf="attach_company.length > 0 && UserForm.controls['type'].value !== 'Company'">
                            <div class="row mt-2 ml-1">
                              <div *ngFor="let company of attach_company" class="col-auto">
                                <div class="company-div">
                                  <span class="f-12 cursor-pointer" (click)="openRightModal(company, 'edit_contact')">{{
                                    company?.company_name
                                  }}</span>
                                  <i
                                    class="pi pi-times-circle ml-2 f-12 cursor-pointer"
                                    (click)="deleteCompany(company?._id, company?.company_name)"></i>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                        <div class="col-12 {{ UserForm.controls['type'].value == 'Company' ? 'pt-0' : '' }}">
                          <div class="searching-address {{ UserForm.controls['type'].value == 'Company' && !isMobile ? 'extra_space' : '' }}">
                            <div class="all-address-fields">
                              <p-accordion>
                                <p-accordionTab [selected]="true">
                                  <div class="row mt-4 pl-2">
                                    <div class="col-lg-12 d-flex align-items-center justify-content-between">
                                      <h4 class="mb-3 f-14 _fw-500">Address</h4>
                                    </div>
                                    <div class="col-xl-11 mb-3">
                                      <input
                                        class="site-input b-none"
                                        [readonly]="isPrivate"
                                        placeholder="Search Address"
                                        google-places-autocomplete
                                        [options]="options"
                                        (onAddressChange)="handleAddressChange($event)"
                                        formControlName="contact_address"
                                        [ngClass]="{
                                          '_input-error': submitted && f.contact_address.errors,
                                        }" />
                                    </div>
                                    <div class="col-sm-1 pl-0">
                                      <button
                                        id="toggle-overlay"
                                        class="_addNew ml-2 mt-0"
                                        (click)="openAddressOverlayPanel($event)"
                                        [class.disabled]="disablePropertyAddress">
                                        <img [src]="common_images?.pencil_icon" class="pencil-cross" width="12" />
                                        <div class="position-relative">
                                          <p-overlayPanel
                                            #ops
                                            [style]="{ width: '500px' }"
                                            appendTo="body"
                                            styleClass="contact-address"
                                            [baseZIndex]="10000"
                                            [autoZIndex]="true"
                                            [dismissable]="true"
                                            [showCloseIcon]="true">
                                            <ng-template pTemplate>
                                              <div class="row">
                                                <div class="col-lg-12 mb-4 d-flex align-items-center justify-content-between">
                                                  <h4 class="f-12 _fw-600">Address</h4>
                                                  <button class="_primary-btn" (click)="updateAddress(); ops.hide($event)">Save</button>
                                                </div>
                                                <div class="col-xl-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Building Name</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.building_name.errors }"
                                                      class="_input"
                                                      formControlName="building_name" />
                                                  </div>
                                                </div>
                                                <div class="col-lg-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Unit No</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.unit_no.errors }"
                                                      class="_input"
                                                      formControlName="unit_no" />
                                                  </div>
                                                </div>
                                                <div class="col-lg-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Street No</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.street_no.errors }"
                                                      class="_input"
                                                      formControlName="street_no" />
                                                  </div>
                                                </div>
                                                <div class="col-xl-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Street Name</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.street_name.errors }"
                                                      class="_input"
                                                      formControlName="street_name" />
                                                  </div>
                                                </div>
                                                <div class="col-xl-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Suburb</p>
                                                    <div class="auto-complete-custom">
                                                      <p-autoComplete
                                                        formControlName="suburb"
                                                        [virtualScroll]="true"
                                                        class="hide-loader"
                                                        [bufferAmount]="10"
                                                        [suggestions]="filteredItems"
                                                        [lazy]="false"
                                                        [ngClass]="{ '_input-error': submitted && f.suburb.errors }"
                                                        [itemSize]="34"
                                                        (completeMethod)="filterItems($event)"
                                                        field="suburb">
                                                      </p-autoComplete>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="col-lg-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">State</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.state.errors }"
                                                      class="_input"
                                                      formControlName="state" />
                                                  </div>
                                                </div>
                                                <div class="col-lg-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Post Code</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.post_code.errors }"
                                                      class="_input"
                                                      formControlName="post_code" />
                                                  </div>
                                                </div>
                                                <div class="col-xl-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Country</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.country.errors }"
                                                      class="_input"
                                                      formControlName="country" />
                                                  </div>
                                                </div>
                                              </div>
                                            </ng-template>
                                          </p-overlayPanel>
                                        </div>
                                      </button>
                                    </div>
                                  </div>
                                </p-accordionTab>
                              </p-accordion>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="px-3 py-1 tags_div">
                        <div class="mt-2 mb-2 d-flex justify-content-between align-items-center">
                          <h4 class="f-14 _fw-500">Tags</h4>
                          <i class="pi pi-plus cursor-pointer f-12 ml-2 text-primary" (click)="handleTabs('clickView')"></i>
                        </div>
                        <div
                          cdkDropList
                          #doneList="cdkDropList"
                          [cdkDropListData]="todo"
                          [cdkDropListConnectedTo]="['todoList', 'todoList_2']"
                          class="example-list"
                          (cdkDropListDropped)="dropTag($event)"
                          class="d-flex align-items-center flex-wrap tags-container pr-2 pt-2 pb-1"
                          *ngIf="todo?.length > 0">
                          <div
                            class="contact-tags mr-2 mb-1 f-12 primary-chip cp p-chip d-inline-flex align-items-center todo_padding"
                            *ngFor="let item of todo; let i = index"
                            [pTooltip]="item?.type">
                            <div class="p-chip-text">{{ item?.tag_name }}</div>
                            <i class="f-12 pi pi-times cp ml-2" (click)="removePublicTag(i)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </app-collapse-box>
                </div>
              </div>
              <div class="mt-3 tab-pane fade show active">
                <app-collapse-box [headingClassName]="'f-14'" [heading]="'Marketing Info'">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group mb-0">
                        <label for="gender">Gender</label>
                        <div class="d-flex align-items-center mt-2 flex_wrap">
                          <div class="d-flex align-items-center p-field-radiobutton">
                            <p-radioButton
                              name="gender"
                              value="Male"
                              formControlName="gender"
                              [disabled]="isPrivate"
                              [ngClass]="{ '_input-error': submitted && f.gender.errors }">
                            </p-radioButton>
                            <label for="gender" class="pl-2">Male</label>
                          </div>
                          <div class="d-flex align-items-center p-field-radiobutton mx-4">
                            <p-radioButton
                              name="gender"
                              value="Female"
                              formControlName="gender"
                              [disabled]="isPrivate"
                              [ngClass]="{ '_input-error': submitted && f.gender.errors }">
                            </p-radioButton>
                            <label for="gender" class="pl-2">Female</label>
                          </div>
                          <div class="d-flex align-items-center p-field-radiobutton">
                            <p-radioButton
                              name="gender"
                              value="not_prefer"
                              formControlName="gender"
                              [disabled]="isPrivate"
                              [ngClass]="{ '_input-error': submitted && f.gender.errors }">
                            </p-radioButton>
                            <label for="gender" class="pl-2">Prefer not to say</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-2 w-130">
                      <div class="form-group mb-0">
                        <label for="">Birthday</label>
                        <div class="w-100 mt-2">
                          <p-inputMask
                            mask="99/99/9999"
                            formControlName="birthday"
                            placeholder="dd/mm/yyyy"
                            slotChar="dd/mm/yyyy"
                            firstDayOfWeek="1"
                            [disabled]="isPrivate"
                            [ngClass]="{
                              '_input-error': submitted && f.birthday.errors,
                            }"></p-inputMask>
                        </div>
                      </div>
                    </div>
                  </div>
                </app-collapse-box>
              </div>
            </div>
            <div class="text-right mt-4">
              <div *ngIf="lmService?.contact_show_div == 'add_contact'">
                <button
                  type="submit"
                  class="_outline-btn ml-auto mr-2 btn-sm"
                  [disabled]="isPrivate"
                  [class.disabled]="submittedBtn"
                  (click)="createContact(false, 'onlyCreate')">
                  Save
                </button>
                <ng-container *ngIf="lmService.tab_levels?.length === 1 && lmService?.contact_show_div == 'add_contact'">
                  <button
                    type="submit"
                    class="_primary-btn ml-auto btn-sm"
                    [disabled]="isPrivate"
                    [class.disabled]="submittedBtn"
                    (click)="createContact(false, 'create')">
                    Save & Close
                  </button>
                </ng-container>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #splitter2>
  <div class="col-lg-12 position-relative cs-b-left overflow-hidden {{ isMobile && showMenu ? 'mobile-padding-bottom' : '' }}">
    <ng-container *ngIf="userRole == 'master admin' || userRole == 'operations manager' || userPermission.includes('contact_process.view')">
      <img *ngFlag="'automation'" [src]="common_images?.automation_icon" class="process-setting" (click)="GetListingWorkflowProcesses()" />
    </ng-container>
    <div class="property-details border-none {{ isMobile ? 'cs-mobile-padding mb-3' : 'cs-padding' }}">
      <div class="d-flex align-items-center primary-tabs b-b-tabs">
        <div class="mobile-tab mb-3" *ngIf="isMobile">
          <p (click)="showMenu = !showMenu">
            <img [src]="selectedItem.icon" class="mr-1" width="15px" />
            {{ selectedItem ? selectedItem.label : 'Property Detail' }}
          </p>
          <i class="pi pi-chevron-down f-14 mobile-tab-icon cursor-pointer" (click)="showMenu = !showMenu"></i>
          <ng-container *ngIf="showMenu">
            <ul class="mobile-tab-menu">
              <ng-container *ngFor="let tab of tabs; let i = index">
                <li (click)="selectItem(tab, i)" *ngFlag="tab.flag">
                  <img [src]="tab.icon" class="mr-1" width="15px" />
                  {{ tab.label }}
                  <span class="badge" *ngIf="getBadgeCount(tab)">
                    {{ getBadgeCount(tab) }}
                  </span>
                </li>
              </ng-container>
            </ul>
          </ng-container>
        </div>

        <ul class="nav nav-pills tools-tab-nav w-100 align-items-end" role="tablist" *ngIf="!isMobile">
          <ng-container *ngFor="let tab of tabs">
            <li
              *ngFlag="tab.flag"
              class="nav-item cursor-pointer"
              role="presentation"
              [hidden]="!isTabVisible(tab)"
              (click)="rightActiveIndex = tab.panel; onChangeRightPanel(tab.label)">
              <a
                [ngClass]="{ active: rightActiveIndex === tab.panel }"
                [id]="'pills-' + tab.id"
                data-bs-toggle="pill"
                [attr.data-bs-target]="'#' + tab.id"
                role="tab"
                [attr.aria-controls]="tab.id"
                [attr.aria-selected]="rightActiveIndex === tab.panel">
                <img [src]="tab.icon" class="mr-1" width="15px" />
                {{ tab.label }}
                <p class="f-10 ml-2 a-head-badge" *ngIf="getBadgeCount(tab)">
                  {{ getBadgeCount(tab) }}
                </p>
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade {{ rightActiveIndex === 0 && 'show active' }}"
          [id]="'cStream' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-cStream' + tabIndex + '-tab'"
          tabindex="0">
          <div class="position-relative">
            <div class="s-custom-entity-records scrol_ overflow-auto pr-2 mxh-700" (scroll)="onStreamScroll($event)" #streamScrollableElement>
              <i class="pi pi-arrow-up" (click)="streamScrollToTop()" *ngIf="streamScrollTop > 50"></i>
              <ng-container>
                <div class="d-flex align-items-center justify-content-between">
                  <div class="filter-by-tasks cs-margin">
                    <div class="position-relative mr-2 w-100">
                      <input
                        type="text"
                        [(ngModel)]="keyword"
                        id="keywordInput"
                        (input)="searchStream($event)"
                        class="_input-icon"
                        placeholder="Search by keyword" />
                      <i class="pi pi-search _search-icon"></i>
                      <i class="pi pi-times _cross-icon" *ngIf="keyword && !isSearching" (click)="keyword = ''; streams = []; getStream()"></i>
                    </div>
                  </div>
                  <div class="mr-1">
                    <p *ngIf="streams?.length > 0">
                      {{ 'Records: ' + totalRecord }}
                    </p>
                  </div>
                </div>
                <div class="stream-overflow" *ngIf="streams?.length">
                  <ng-container *ngFor="let itm of streams">
                    <ng-container *ngIf="itm.type == 'property_appointment'">
                      <div class="stream-body b-light-bottom">
                        <div class="d-flex align-items-end my-3">
                          <div>
                            <div class="d-flex align-items-center mb-2">
                              <i class="pi pi-calendar f-16 mr-2" aria-hidden="true"></i>
                              <p class="f-12 mr-2 _fw-600 text-capitalize">
                                <span>{{ itm?.summary }} </span>
                              </p>
                            </div>
                            <div class="d-flex align-items-center">
                              <i class="pi pi-map-marker f-16 mr-2" aria-hidden="true"></i>
                              <p class="f-12 _fw-600">
                                <span>{{ itm?.misc?.event?.location }}</span>
                              </p>
                            </div>
                          </div>
                          <span class="f-10 ml-auto text-dark">{{ parseDate(itm?.created_at) | date: 'EEE d MMM y h:mma' }}</span>
                        </div>
                        <div>
                          <div class="align-items-center justify-content-between mb-1">
                            <div class="{{ isMobile ? 'd-flex align-items-senter justify-content-between' : 'row' }}">
                              <div class="col-sm-2">
                                <p class="mb-2 f-12"><span>Type</span></p>
                                <p class="mb-2 f-12"><span>Start</span></p>
                                <p class="mb-2 f-12"><span>End</span></p>
                              </div>
                              <div class="col-sm-10">
                                <p class="mb-2 f-12">{{ itm?.misc?.type }}&nbsp;</p>
                                <p class="mb-2 f-12 text-dark">
                                  {{
                                    itm?.misc?.event?.start?.dateTime
                                      | date
                                        : 'EEE d MMM y
                                  h:mma'
                                  }}&nbsp;
                                </p>
                                <p class="mb-2 f-12 text-dark">
                                  {{
                                    itm?.misc?.event?.end?.dateTime
                                      | date
                                        : 'EEE d MMM y
                                  h:mma'
                                  }}&nbsp;
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="itm.type == 'LeadContact'">
                      <div class="stream-body b-light-bottom">
                        <div>
                          <div class="d-flex align-items-center my-3">
                            <i class="pi pi-circle-on f-16 mr-2 {{ itm?.lead_status?.toLowerCase().replaceAll(' ', '-') }}" aria-hidden="true"></i>
                            <p class="f-12 _fw-600 text-capitalize">
                              <span>{{ itm?.summary }}</span> {{ itm?.lead_status }}
                            </p>
                            <span class="f-10 ml-auto text-dark">{{
                              parseDate(itm?.created_at)
                                | date
                                  : 'EEE d MMM y
                              h:mma'
                            }}</span>
                          </div>
                        </div>
                        <div>
                          <div class="d-flex align-items-center justify-content-between mb-3">
                            <a class="f-12 view_lead" href="javascript:void(0)" (click)="_editLead(itm?.lead_id)">View Lead</a>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="itm.type == 'relatedcontacts'">
                      <div class="stream-body b-light-bottom">
                        <div>
                          <div class="d-flex align-items-end my-3 Relationship-work">
                            <i class="pi pi-map-marker f-16 mr-2" aria-hidden="true"></i>
                            <p class="f-12 _fw-600 text-capitalize">
                              <span>{{ itm?.summary }}</span>
                              {{ itm?.property?.property_address }}
                            </p>
                            <span class="f-10 ml-auto text-dark">{{
                              parseDate(itm?.created_at)
                                | date
                                  : 'EEE d MMM y
                              h:mma'
                            }}</span>
                          </div>
                        </div>
                        <div>
                          <div class="{{ isMobile ? 'd-flex align-items-senter justify-content-between' : 'row' }}">
                            <p class="col-sm-2 f-10 des-date-time-color">Name</p>
                            <p class="col-sm-10 f-10 des-date-time-color">{{ itm?.name }}</p>
                          </div>
                          <div
                            class="{{ isMobile ? 'd-flex align-items-senter justify-content-between' : 'row' }}"
                            *ngIf="itm?.misc?.relation?.length > 0">
                            <p class="col-sm-2 f-10 des-date-time-color">Relationship</p>
                            <p class="col-sm-10 f-10 des-date-time-color">
                              {{ itm?.misc?.relation?.toString().replaceAll(',', ', ') }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!['property_appointment', 'LeadContact', 'relatedcontacts'].includes(itm.type)">
                      <div *ngIf="itm.record_source == 'history'" class="stream-body b-light-bottom">
                        <div *ngIf="itm.apt">
                          <div class="d-flex align-items-end my-3">
                            <img class="img-20 dark mr-2 mt_minus" [src]="common_images?.contact_lead_icon" />
                            <div class="d-flex">
                              <div>
                                <p class="f-12 _fw-600 text-capitalize">
                                  <span>{{ itm?.summary }}</span>
                                </p>
                                <div [innerHTML]="itm?.desc"></div>
                              </div>
                            </div>
                            <span class="f-12 text-lowercase ml-auto des-date-time-color text-dark">{{
                              itm?.created_at | date: 'EEE d MMM y h:mma'
                            }}</span>
                          </div>
                        </div>
                        <div *ngIf="!itm.apt">
                          <div class="d-flex align-items-center my-3">
                            <i class="pi pi-map-marker f-16 mr-2" aria-hidden="true"></i>
                            <p class="f-12 _fw-600 text-capitalize">
                              <span>{{ itm?.summary }}</span>
                              {{ itm?.property?.property_address }}
                            </p>
                            <span class="f-10 ml-auto text-dark">{{ itm?.created_at | date: 'EEE d MMM y h:mma' }}</span>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="itm.record_source != 'history'" class="stream-body b-light-bottom">
                        <div>
                          <div class="d-flex align-items-end my-3 history-work">
                            <i class="pi pi-map-marker f-16 mr-2" aria-hidden="true"></i>
                            <p class="f-12 _fw-600 text-capitalize">
                              <span>{{ itm?.summary }}</span>
                              {{ itm?.property?.property_address }}
                            </p>
                            <span class="f-10 ml-auto text-dark">{{
                              parseDate(itm?.created_at)
                                | date
                                  : 'EEE d MMM y
                              h:mma'
                            }}</span>
                          </div>
                        </div>
                        <div>
                          <div class="align-items-center justify-content-between mb-1">
                            <div class="{{ isMobile ? 'd-flex align-items-senter justify-content-between' : 'row' }}">
                              <p class="col-sm-2 f-10 des-date-time-color">Detail</p>
                              <p class="col-sm-10 f-10 des-date-time-color">
                                {{ itm?.detail }}
                              </p>
                            </div>
                            <div class="{{ isMobile ? 'd-flex align-items-senter justify-content-between' : 'row' }}">
                              <p class="col-sm-2 f-10 des-date-time-color">Description</p>
                              <p class="col-sm-10 f-10 des-date-time-color">{{ itm?.desc2 }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
          <ng-container *ngIf="!streams?.length">
            <div class="d-flex align-items-center">
              <img [src]="common_images?.stream_new" class="email-connect mr-4" />
              <p class="f-12">No Updates Yet</p>
            </div>
          </ng-container>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 1 && 'show active' }}"
          [id]="'cLead' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-cLead' + tabIndex + '-tab'"
          tabindex="0">
          <ng-container *ngIf="stats['totalleads']?.length">
            <div>
              <div class="d-flex align-items-center justify-content-between flex-wrap w-100">
                <p class="f-12 _fw-600">Records: {{ stats['totalleads']?.length }}</p>
                <button *ngxPermissionsOnly="['lead.add']" class="_outline-btn mt-2 ml-auto" (click)="newLead()">
                  <i class="pi pi-plus mr-2 f-12 text-primary"></i> New Lead
                </button>
              </div>
              <div class="position-relative w-100 mt-3">
                <div class="s-custom-entity-records scrol_ mxh-600" (scroll)="onsideLeadScroll($event)" #sideLeadScrollableElement>
                  <i class="pi pi-arrow-up" (click)="sideLeadScrollToTop()" *ngIf="sideLeadScrollTop > 50"></i>
                  <p-table id="customentitydatalist" [value]="stats['totalleads']" dataKey="_id" [rowHover]="false" [rows]="sideLeadRows">
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="lead_th_1">&nbsp;</th>
                        <th class="lead_th_2">Date</th>
                        <th class="lead_th_3">Status</th>
                        <th class="lead_th_4">Listing/Projects</th>
                        <th class="lead_th_5">Lead Source</th>
                        <th class="lead_th_6">Agent</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-lead>
                      <tr class="cp" *ngIf="lead.agent == AuthUser._id || AuthUser?.role == 'Operations Manager' || AuthUser.role == 'Master Admin'">
                        <td class="lead_td_1">
                          <img
                            [src]="images?.people_add_user"
                            alt="user-minus"
                            width="12px"
                            class="cursor-pointer mr-3"
                            pTooltip="Remove Assigned"
                            (click)="removeAssignment(lead)"
                            *ngIf="lead?.agent !== AuthUser?._id" />
                          <i class="cursor-pointer f-16 pi pi-clone" pTooltip="Duplicate" (click)="duplicateRecords(lead)"></i>
                        </td>
                        <td
                          class="lead_tds"
                          (click)="editLead(lead)"
                          class="text-ellipsis"
                          [ngStyle]="{
                            'font-weight': lead?.is_read === false ? 'bold' : 'normal',
                          }">
                          {{ lead?.created_at | date: 'dd/MM/yy' }}
                        </td>
                        <td
                          class="lead_tds"
                          (click)="editLead(lead)"
                          class="text-ellipsis"
                          [ngStyle]="{
                            'font-weight': lead?.is_read === false ? 'bold' : 'normal',
                          }">
                          {{ lead?.lead_status }}
                        </td>
                        <td
                          class="lead_tds"
                          (click)="editLead(lead)"
                          class="text-ellipsis"
                          [ngStyle]="{
                            'font-weight': lead?.is_read === false ? 'bold' : 'normal',
                          }">
                          {{ lead?.property ? lead?.property : lead?.project }}
                        </td>
                        <td
                          class="lead_tds"
                          (click)="editLead(lead)"
                          class="text-ellipsis"
                          [ngStyle]="{
                            'font-weight': lead?.is_read === false ? 'bold' : 'normal',
                          }">
                          {{ lead?.lead_source }}
                        </td>
                        <td
                          class="lead_tds"
                          (click)="editLead(lead)"
                          class="text-ellipsis"
                          [ngStyle]="{
                            'font-weight': lead?.is_read === false ? 'bold' : 'normal',
                          }">
                          {{ lead?.agent_responsible }}
                        </td>
                      </tr>
                      <tr class="cp" *ngIf="lead.agent != AuthUser._id && AuthUser?.role != 'Operations Manager' && AuthUser.role != 'Master Admin'">
                        <td class="lead_else_td_1">
                          <img
                            [src]="images?.people_add_user"
                            alt="user-minus"
                            width="12px"
                            class="cursor-pointer mr-3"
                            pTooltip="Remove Assigned"
                            (click)="removeAssignment(lead)"
                            *ngIf="lead?.agent !== AuthUser?._id" />
                          <i class="cursor-pointer f-12 pi pi-clone" pTooltip="Duplicate" (click)="duplicateRecords(lead)"></i>
                        </td>
                        <td class="lead_else_tds" (click)="editLead(lead)" class="text-ellipsis">
                          {{ lead?.created_at | date: 'dd/MM/yy' }}
                        </td>
                        <td class="lead_else_tds" (click)="editLead(lead)" class="text-ellipsis">
                          {{ lead?.lead_status }}
                        </td>
                        <td class="lead_else_tds" (click)="editLead(lead)" class="text-ellipsis">
                          {{ lead?.property ? lead?.property : lead?.project }}
                        </td>
                        <td class="lead_else_tds" (click)="editLead(lead)" class="text-ellipsis">
                          {{ lead?.lead_source }}
                        </td>
                        <td class="lead_else_tds" (click)="editLead(lead)" class="text-ellipsis">
                          {{ lead?.agent_responsible }}
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="5">No record found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="d-flex align-items-center flex-wrap w-100 justify-content-between" *ngIf="!stats['totalleads']?.length">
            <div class="d-flex align-items-center">
              <img [src]="common_images?.enquiry" class="w-50px" />
              <p class="f-12">Assign leads to one contact.</p>
            </div>
            <button *ngxPermissionsOnly="['lead.add']" class="_outline-btn mt-2" (click)="newLead()">
              <i class="pi pi-plus mr-2 f-12 text-primary"></i> New Lead
            </button>
          </div>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 2 && 'show active' }}"
          [id]="'cAppointments' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-cAppointments' + tabIndex + '-tab'"
          tabindex="0">
          <ng-container>
            <div class="position-relative scroll_landing_page mt-2">
              <p-table [value]="appointments">
                <ng-template pTemplate="header">
                  <tr>
                    <th class="w-250p">Address</th>
                    <th>Appointment Time</th>
                    <th>Agent</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-appointment>
                  <tr class="cursor-pointer">
                    <td>{{ appointment?.location ? appointment?.location : appointment?.final_summary }}</td>
                    <td>
                      <span class="time-range min-w-130">
                        {{ getTimeFormat(appointment.start.dateTime) }} -
                        {{ getTimeFormat(appointment.end.dateTime) }}
                      </span>
                      <span>
                        {{ appointment.start.dateTime | date: 'EEE d MMM y' }}
                      </span>
                    </td>
                    <td>{{ appointment?.agent?.full_name }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="5">No record found.</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </ng-container>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 3 && 'show active' }}"
          [id]="'cTasks' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-cTasks' + tabIndex + '-tab'"
          tabindex="0">
          <ng-container>
            <div class="contactTabTasks">
              <div *ngIf="!fullList?.length">
                <div class="d-flex w-400px align-items-center">
                  <img [src]="images?.contact_task" class="w-50px" />
                  <p class="l-h-1-31 f-12">Create tasks to associate with this contact.</p>
                </div>
              </div>
              <div class="ml-2">
                <p *ngIf="fullList?.length > 0">
                  {{ 'Records: ' + fullList?.length }}
                </p>
              </div>
              <button *ngxPermissionsOnly="['task.create']" class="_outline-btn mt-2 mb-2 ml-auto" (click)="addNewTask(null, true)">
                <i class="pi pi-plus mr-2 f-12 text-primary"></i> New Task
              </button>
            </div>
            <ng-container *ngIf="fullList?.length && fullList[0]">
              <div class="position-relative" *ngIf="fullList?.length">
                <div class="s-custom-entity-records scrol_ history mxh-500" (scroll)="onsideTaskScroll($event)" #sideTaskScrollableElement>
                  <i class="pi pi-arrow-up" (click)="sideTaskScrollToTop()" *ngIf="sideTaskScrollTop > 50"></i>
                  <p-table
                    id="customentitydatalist"
                    [value]="fullList"
                    dataKey="_id"
                    [rowHover]="false"
                    [rows]="sideTaskRows"
                    (sortFunction)="onRContactSort($event)"
                    [customSort]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="w-40"></th>
                        <th>Title</th>
                        <th>Job Type</th>
                        <th>Task Status</th>
                        <th>Due Date</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-task>
                      <tr>
                        <td>
                          <i class="pi pi-exclamation-triangle" *ngIf="task?.is_exclamation"></i>
                        </td>
                        <td class="cursor-pointer" (click)="addNewTask(task, false)">
                          {{ task?.title }}
                        </td>
                        <td class="cursor-pointer" (click)="addNewTask(task, false)">
                          {{ task?.jobTypeName }}
                        </td>
                        <td class="cursor-pointer" (click)="addNewTask(task, false)">
                          {{ task?.taskStatusName }}
                        </td>
                        <td class="cursor-pointer" (click)="addNewTask(task, false)">
                          {{ task?.due_date | date: 'dd/MM/yy' }}
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="5">No record found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 4 && 'show active' }}"
          [id]="'rProperty' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-rProperty' + tabIndex + '-tab'"
          tabindex="0">
          <ng-container>
            <div class="d-flex align-items-center primary-tabs b-b-tabs">
              <ul class="nav tools-tab-nav w-100 align-items-end" role="tablist">
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="active pl-0"
                    [id]="'pills-listing' + tabIndex + '-tab'"
                    data-bs-toggle="pill"
                    (click)="rPropActiveIndex = 1"
                    [attr.data-bs-target]="'#listing' + tabIndex"
                    role="tab"
                    [attr.aria-controls]="'listing' + tabIndex"
                    aria-selected="true">
                    <img [src]="images?.contact_stream" alt="Listing" width="14px" class="mr-1" />
                    Listing
                    <p class="f-10 ml-2 a-head-badge" *ngIf="attached_listing?.length > 0">
                      {{ attached_listing?.length }}
                    </p>
                  </a>
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class=""
                    [id]="'pills-property' + tabIndex + '-tab'"
                    data-bs-toggle="pill"
                    (click)="rPropActiveIndex = 2"
                    [attr.data-bs-target]="'#property' + tabIndex"
                    role="tab"
                    [attr.aria-controls]="'property' + tabIndex"
                    aria-selected="false">
                    <img [src]="common_images?.home" alt="Property" width="14px" class="mr-1" />
                    Property
                    <p class="f-10 ml-2 a-head-badge" *ngIf="attached_properties?.length > 0">
                      {{ attached_properties?.length }}
                    </p>
                  </a>
                </li>
                <li class="nav-item cursor-pointer" role="presentation" *ngFlag="'contracts'">
                  <a
                    class=""
                    [id]="'pills-contract' + tabIndex + '-tab'"
                    data-bs-toggle="pill"
                    (click)="rPropActiveIndex = 3"
                    [attr.data-bs-target]="'#contract' + tabIndex"
                    role="tab"
                    [attr.aria-controls]="'contract' + tabIndex"
                    aria-selected="false">
                    <img [src]="images?.contact_contract" alt="Contract" width="14px" class="mr-1" />
                    Contract
                    <p class="f-10 ml-2 a-head-badge" *ngIf="attached_contracts?.length > 0">
                      {{ attached_contracts?.length }}
                    </p>
                  </a>
                </li>
              </ul>
            </div>
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade {{ rPropActiveIndex === 1 && 'show active' }}"
                [id]="'listing' + tabIndex"
                role="tabpanel"
                [attr.aria-labelledby]="'pills-listing' + tabIndex + '-tab'"
                tabindex="0">
                <div class="d-flex align-items-center my-3">
                  <div class="w-100 pr-3">
                    <span class="p-input-icon-left w-100">
                      <i class="pi pi-search search_i"></i>
                      <p-autoComplete
                        class="autocomplete-icon"
                        [(ngModel)]="attach_listing"
                        [virtualScroll]="false"
                        [suggestions]="filteredListing"
                        field="property_address"
                        (completeMethod)="searchListing($event)"
                        (onSelect)="listingSelection($event)"
                        placeholder="Search Listing">
                      </p-autoComplete>
                    </span>
                  </div>
                  <div>
                    <button class="preview-btn btn-sm f-12" (click)="attachListing()" [class.disabled]="listingBtnDisable">Associate</button>
                  </div>
                </div>
                <div class="mb-2" *ngIf="!filteredListing?.length && property_search_complete">
                  <a class="custom-a fs-12" href="javascript:void(0)" (click)="openRightModal(null, 'add_property')">
                    <i class="pi pi-plus f-10 mr-2"></i>Add New Property
                  </a>
                </div>
                <div class="contact-tags w-100" *ngIf="attached_listing?.length">
                  <div class="p-3 r_listing">
                    <p class="f-12 font-weight-bold">Contact Type</p>
                    <div
                      class="d-flex align-items-center flex-wrap"
                      *ngIf="contactType"
                      cdkDropList
                      [cdkDropListConnectedTo]="getListingConnectedTo()">
                      <span class="related-tag primary-chip" *ngFor="let tag of contactType" cdkDrag [cdkDragData]="tag.tag_name">
                        <span class="p-tag-value">{{ tag.tag_name }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="p-3 mt-4 r_listing">
                    <p class="f-12 font-weight-bold">Related Tags</p>
                    <div
                      class="d-flex align-items-center flex-wrap"
                      *ngIf="relatedContactTags"
                      cdkDropList
                      [cdkDropListConnectedTo]="getListingConnectedTo()">
                      <span class="related-tag primary-chip" *ngFor="let tag of relatedContactTags" cdkDrag [cdkDragData]="tag.tag_name">
                        <span class="p-tag-value">{{ tag.tag_name }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="position-relative mt-3">
                  <div class="s-custom-entity-records scrol_ history mxh-300" (scroll)="onSideListingScroll($event)" #sideListingScrollableElement>
                    <i class="pi pi-arrow-up" (click)="sideListingScrollToTop()" *ngIf="sideListingScrollTop > 50"></i>
                    <p-table
                      styleClass="pagination-dropdown"
                      scrollWidth="100%"
                      dataKey="_id"
                      [value]="attached_listing"
                      [paginator]="false"
                      [rows]="sideListingRows"
                      [(selection)]="selectedRows">
                      <ng-template pTemplate="header">
                        <tr>
                          <th class="px-0 w-10"></th>
                          <th pSortableColumn="type">Tags<p-sortIcon field="type" class="ml-2"></p-sortIcon></th>
                          <th pSortableColumn="property.property_address">
                            Address<p-sortIcon field="property.property_address" class="ml-2"></p-sortIcon>
                          </th>
                          <th pSortableColumn="property.property_status">
                            Status<p-sortIcon field="property.property_status" class="ml-2"></p-sortIcon>
                          </th>
                          <th pSortableColumn="property.value">Price<p-sortIcon field="property.value" class="ml-2"></p-sortIcon></th>
                          <th pSortableColumn="property.contract_status">
                            Created Date<p-sortIcon field="property.contract_status" class="ml-2"></p-sortIcon>
                          </th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-listing>
                        <tr>
                          <td class="pl-0">
                            <button class="btn p-0" (click)="deleteAttachedListing(listing?._id, 'listing')">
                              <img [src]="common_images?.delete_icon" alt="delete" width="16px" />
                            </button>
                          </td>
                          <td
                            cdkDropList
                            [id]="'s_' + listing?._id"
                            [cdkDropListData]="listing['type']"
                            (cdkDropListDropped)="dropListing($event, listing)">
                            <div class="listing-tags">
                              <ng-container *ngFor="let tag of listing['type']">
                                <p-chip styleClass="mr-1 f-10 primary-chip">
                                  <span class="p-chip-text">{{ tag }}</span>
                                  <i class="pi pi-times f-10 ml-1 cursor-pointer" (click)="removelistingTag(tag, listing)"></i>
                                </p-chip>
                              </ng-container>
                            </div>
                          </td>
                          <td class="cursor-pointer text-captilize space-normal" (click)="openRightModal(listing?.property, 'edit_listing_property')">
                            {{ listing?.property.property_address }}
                          </td>
                          <td class="cursor-pointer text-captilize" (click)="openRightModal(listing?.property, 'edit_listing_property')">
                            {{ listing?.property.property_status }}
                          </td>
                          <td class="cursor-pointer text-captilize" (click)="openRightModal(listing?.property, 'edit_listing_property')">
                            <span *ngIf="listing?.property?.value">{{ listing.property.value | currency: 'USD' : true : '1.0-0' }}</span>
                          </td>
                          <td class="cursor-pointer text-captilize" (click)="openRightModal(listing?.property, 'edit_listing_property')">
                            {{
                              listing?.associate_date
                                ? (listing?.associate_date | date: 'dd/MM/yy')
                                : (listing?.property.created_at | date: 'dd/MM/yy')
                            }}
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="7">No record found.</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade {{ rPropActiveIndex === 2 && 'show active' }}"
                [id]="'property' + tabIndex"
                role="tabpanel"
                [attr.aria-labelledby]="'pills-property' + tabIndex + '-tab'"
                tabindex="0">
                <div class="d-flex align-items-center my-3">
                  <div class="w-100 pr-3">
                    <span class="p-input-icon-left w-100">
                      <i class="pi pi-search search_i"></i>
                      <p-autoComplete
                        class="autocomplete-icon"
                        [(ngModel)]="attach_property"
                        [virtualScroll]="false"
                        [suggestions]="filteredProperty"
                        field="property_address"
                        (completeMethod)="searchProperties($event)"
                        (onSelect)="propertySelection($event)"
                        placeholder="Search Property">
                      </p-autoComplete>
                    </span>
                  </div>
                  <div>
                    <button class="btn-sm preview-btn f-12" (click)="attachProperty()" [class.disabled]="listingBtnDisable">Associate</button>
                  </div>
                </div>
                <div class="my-3" *ngIf="!filteredProperty?.length && property_search_complete">
                  <a class="custom-a f-12" href="javascript:void(0)" (click)="openRightModal(null, 'add_property')">
                    <i class="pi pi-plus f-10 mr-2"></i>Add New Property
                  </a>
                </div>
                <div class="mt-2 pt-2 r-property-table">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="position-relative">
                        <div
                          class="s-custom-entity-records scrol_ history mxh-400"
                          (scroll)="onSidePropertyScroll($event)"
                          #sidePropertyScrollableElement>
                          <i class="pi pi-arrow-up" (click)="sidePropertyScrollToTop()" *ngIf="sidePropertyScrollTop > 50"></i>
                          <p-table
                            scrollWidth="100%"
                            dataKey="_id"
                            [value]="attached_properties"
                            [paginator]="false"
                            [rows]="sidePropertyRows"
                            [(selection)]="selectedRows">
                            <ng-template pTemplate="header">
                              <tr>
                                <th class="pl-0 w-40"></th>
                                <th pSortableColumn="type">Tags<p-sortIcon field="type" class="ml-2"></p-sortIcon></th>
                                <th pSortableColumn="property_data.property_address">
                                  Address<p-sortIcon field="property_data.property_address" class="ml-2"></p-sortIcon>
                                </th>
                                <th pSortableColumn="property_data.type">Type<p-sortIcon class="ml-2" field="property_data.type"></p-sortIcon></th>
                                <th pSortableColumn="property_data.date">
                                  Settlement Date
                                  <p-sortIcon class="ml-2" field="property_data.date"></p-sortIcon>
                                </th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-listing>
                              <tr>
                                <td>
                                  <button class="btn p-0" (click)="deleteAttachedProperty(listing?._id)">
                                    <img [src]="common_images?.delete_icon" alt="delete" width="16px" />
                                  </button>
                                </td>
                                <td class="cursor-pointer text-captilize" (click)="openRightModal(listing?.property_data, 'edit_property')">
                                  {{ listing?.type }}
                                </td>
                                <td
                                  class="cursor-pointer text-captilize space-normal"
                                  (click)="openRightModal(listing?.property_data, 'edit_property')">
                                  {{ listing?.property_data?.property_address }}
                                </td>
                                <td class="cursor-pointer text-captilize" (click)="openRightModal(listing?.property_data, 'edit_property')">
                                  {{ listing?.property_data?.type }}
                                </td>
                                <td class="cursor-pointer text-captilize" (click)="openRightModal(listing?.property, 'edit_listing_property')">
                                  <ng-container *ngIf="listing?.date; else no_settle">
                                    {{ listing?.date | date: 'dd/MM/yy' }}
                                  </ng-container>
                                  <ng-template #no_settle>
                                    {{ listing?.property_data?.date | date: 'dd/MM/yy' }}
                                  </ng-template>
                                </td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="7">No record found.</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade {{ rPropActiveIndex === 3 && 'show active' }}"
                [id]="'contract' + tabIndex"
                role="tabpanel"
                [attr.aria-labelledby]="'pills-contract' + tabIndex + '-tab'"
                tabindex="0">
                <div class="mt-3">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="position-relative">
                        <div class="s-custom-entity-records scrol_" (scroll)="onSideContractScroll($event)" #sideContractScrollableElement>
                          <i class="pi pi-arrow-up" (click)="sideContractScrollToTop()" *ngIf="sideContractScrollTop > 50"></i>
                          <p-table
                            scrollWidth="100%"
                            dataKey="_id"
                            [value]="attached_contracts"
                            [paginator]="false"
                            [rows]="sideContractRows"
                            [(selection)]="selectedRows">
                            <ng-template pTemplate="header">
                              <tr>
                                <th class="pl-0 w-40"></th>
                                <th class="contract_th" class="pl-3">Tags</th>
                                <th class="contract_th_1">Address</th>
                                <th class="contract_th">Status</th>
                                <th class="contract_th_2">Offer Price</th>
                                <th class="contract_th_3">Contract Issue date</th>
                                <th class="contract_th">Cancelled</th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-contract>
                              <tr>
                                <td class="w-auto">
                                  <button class="btn p-0" (click)="deleteAttachedListing(contract?._id, 'contract')">
                                    <img [src]="common_images?.delete_icon" alt="delete" width="14px" />
                                  </button>
                                </td>
                                <td class="cursor-pointer w-auto text-captilize" (click)="openRightModal(contract, 'edit_contract')">
                                  {{ contract?.type }}
                                </td>
                                <td class="cursor-pointer w-auto text-captilize" (click)="openRightModal(contract, 'edit_contract')">
                                  {{ contract?.property_address ? contract?.property_address : contract?.project_name }}
                                </td>
                                <td class="cursor-pointer w-auto text-captilize" (click)="openRightModal(contract, 'edit_contract')">
                                  {{ contract?.offer_status ? contract?.offer_status : contract?.contractStatus }}
                                </td>
                                <td class="cursor-pointer w-auto text-captilize" (click)="openRightModal(contract, 'edit_contract')">
                                  {{ contract?.offerPrice ? contract?.offerPrice : (contract?.contract_price | currency: 'USD' : true : '1.0-0') }}
                                </td>
                                <td class="cursor-pointer w-auto text-captilize" (click)="openRightModal(contract, 'edit_contract')">
                                  <ng-container *ngIf="contract?.contractIssuedDate; else noissueDate">
                                    {{ contract?.contractIssuedDate | date: 'dd/MM/yy' }}
                                  </ng-container>
                                  <ng-template #noissueDate>
                                    {{ contract?.contract_issued_date | date: 'dd/MM/yy' }}
                                  </ng-template>
                                </td>
                                <td class="cursor-pointer w-auto text-captilize" (click)="openRightModal(contract, 'edit_contract')">
                                  {{ contract?.cancelledDate || contract?.cancelled_date ? 'Yes' : 'No' }}
                                </td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="7">No record found.</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 5 && 'show active' }}"
          [id]="'rContact' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-rContact' + tabIndex + '-tab'"
          tabindex="0">
          <ng-container>
            <div class="d-flex w-400px align-items-center" *ngIf="!attached_contacts?.length">
              <img [src]="images?.related_contact" class="w-50px" />
              <div>
                <p class="l-h-1-31 f-12">Search contacts to associate with this contact.</p>
              </div>
            </div>
            <div class="mb-1">
              <div class="row align-items-end">
                <div class="col-sm-10 pb-1 p-autocomplete-70 position-relative" style="width: 300px">
                  <label for="" style="width: 100%">
                    <re-multiselect
                      [module]="'contacts'"
                      [placeholder]="'Select'"
                      [truncate]="25"
                      [isMultiple]="false"
                      [isCreateNew]="false"
                      [isClear]="true"
                      [isEmail]="true"
                      [isFullObject]="true"
                      [escapeOverflow]="true"
                      (createNew)="openRightModal(null, 'add_contact')"
                      [selected_ids]="selectedRelatedContact"
                      (onUpdate)="contactSelection($event)"
                      [style]="{ width: '100%' }"></re-multiselect>
                  </label>
                </div>
                <div class="col-2">
                  <button class="_outline-btn" (click)="attachContact()" [class.disabled]="isAttachingContact" [disabled]="isAttachingContact">
                    Associate
                  </button>
                </div>
              </div>
              <p class="f-12 mt-1">When creating a new Contact, press Save and not Save and Close</p>
            </div>
            <ng-container *ngIf="attached_contacts?.length > 0 && attached_contacts[0]">
              <div class="col-12 contact-tags mt-3 px-0" *ngIf="attached_contacts?.length">
                <div *ngIf="UserForm.controls['type'].value !== 'Company'">
                  <div class="cs-related-contact">
                    <p class="f-12 font-weight-bold">Contact Type</p>
                    <div class="d-flex align-items-center flex-wrap" *ngIf="contactType" cdkDropList [cdkDropListConnectedTo]="getConnectedTo()">
                      <span class="related-tag primary-chip" *ngFor="let tag of contactType" cdkDrag [cdkDragData]="tag.tag_name">
                        <span class="p-tag-value">{{ tag.tag_name }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="cs-related-contact">
                    <p class="f-12 font-weight-bold mt-3">Relationship</p>
                    <div class="d-flex align-items-center flex-wrap" cdkDropList [cdkDropListConnectedTo]="getConnectedTo()">
                      <span class="related-tag primary-chip" *ngFor="let tag of lmService.contact_relations" cdkDrag [cdkDragData]="tag.name">
                        <span class="p-tag-value">{{ tag.name }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div *ngIf="UserForm.controls['type'].value === 'Company'">
                  <div class="cs-related-contact">
                    <p class="f-14 font-weight-bold">Company Role</p>
                    <div class="d-flex align-items-center flex-wrap" cdkDropList [cdkDropListConnectedTo]="getConnectedTo()">
                      <span class="related-tag primary-chip" *ngFor="let tag of companyRole" cdkDrag [cdkDragData]="tag.tag_name">
                        <span class="p-tag-value">{{ tag.tag_name }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="position-relative mt-2">
                  <div
                    class="s-custom-entity-records rcontact-table scrol_ history mxh-300"
                    (scroll)="onRelatedContactScroll($event)"
                    #relatedContactScrollableElement>
                    <i class="pi pi-arrow-up" (click)="relatedContactScrollToTop()" *ngIf="relatedContactScrollTop > 50"></i>
                    <p-table
                      id="customentitydatalist"
                      class="related_contacts"
                      [value]="attached_contacts"
                      [columns]="ContactColumns"
                      dataKey="_id"
                      [rowHover]="false"
                      [rows]="relatedContactRows"
                      (sortFunction)="lmService.customSort($event)"
                      [customSort]="true"
                      [autoLayout]="true"
                      [resizableColumns]="true">
                      <ng-template pTemplate="header">
                        <tr>
                          <th class="text-center w-10"></th>
                          <ng-container *ngFor="let col of ContactColumns">
                            <th class="f-12" *ngIf="col.column != '_id' && col.column != 'Email'" [pSortableColumn]="col.field">
                              <div class="p-d-flex p-ai-center">
                                {{ col.column }}
                                <p-sortIcon [field]="col.field" class="ml-2"></p-sortIcon>
                              </div>
                            </th>
                            <th class="f-12" *ngIf="col.column == 'Email'" [pSortableColumn]="col.field">
                              <div class="p-d-flex p-ai-center">
                                {{ col.column }}
                                <p-sortIcon [field]="col.field" class="ml-2"></p-sortIcon>
                              </div>
                            </th>
                          </ng-container>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-task let-columns="columns">
                        <tr class="cp">
                          <td class="rContact_td">
                            <button class="btn p-0">
                              <img [src]="common_images?.delete_icon" alt="delete" width="16px" (click)="deleteAttachedContact(task._id)" />
                            </button>
                          </td>
                          <ng-container *ngFor="let col of ContactColumns">
                            <td
                              cdkDropList
                              [id]="'s_' + task?._id"
                              class="cursor-pointer"
                              *ngIf="col.field === 'relation'"
                              [cdkDropListData]="task['type']"
                              (cdkDropListDropped)="drop($event, task)">
                              <ng-container *ngFor="let tag of task['relation']">
                                <p-chip styleClass="mr-2 f-10 primary-chip">
                                  <span class="p-chip-text">{{ tag }}</span>
                                  <i class="pi pi-times f-10 ml-1 cursor-pointer" (click)="removeTag(tag, task)"></i>
                                </p-chip>
                              </ng-container>
                            </td>
                            <td class="cursor-pointer" *ngIf="col.field !== 'relation'" (click)="openRightModal(task?.contact, 'edit_contact')">
                              <p class="f-12 pl-0">
                                <ng-container *ngIf="col.field !== 'address' && col.field !== 'full_name'">
                                  {{ task['contact'][col.field] }}
                                </ng-container>
                                <ng-container *ngIf="col.field === 'address'">
                                  {{ task['contact']['property_address'] }}
                                </ng-container>
                                <ng-container *ngIf="col.field === 'full_name'">
                                  {{ task['contact']['full_name'] }}
                                </ng-container>
                              </p>
                            </td>
                          </ng-container>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td class="w-auto" colspan="4">No record found.</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  <div class="mt-2">
                    <p *ngIf="attached_contacts?.length > 0">
                      {{ 'Records: ' + attached_contacts?.length }}
                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 6 && 'show active' }}"
          [id]="'Associations' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-Associations' + tabIndex + '-tab'"
          tabindex="0">
          <div class="d-flex align-items-center primary-tabs b-b-tabs">
            <ul class="nav tools-tab-nav w-100 align-items-end" role="tablist">
              <li class="nav-item cursor-pointer" role="presentation">
                <a
                  class="active"
                  [id]="'pills-project_associate' + tabIndex + '-tab'"
                  data-bs-toggle="pill"
                  [attr.data-bs-target]="'#project_associate' + tabIndex"
                  role="tab"
                  [attr.aria-controls]="'project_associate' + tabIndex"
                  aria-selected="false">
                  Associations
                  <p class="f-10 ml-2 a-head-badge" *ngIf="AssociatedProjectsUsers?.length > 0">
                    {{ AssociatedProjectsUsers?.length }}
                  </p>
                </a>
              </li>
              <li
                class="nav-item cursor-pointer"
                role="presentation"
                *ngIf="
                  (userPermission.includes('agreement.view') || userRole == 'master admin' || userRole == 'operations manager') && !disabled_tab
                ">
                <a
                  class=""
                  [id]="'pills-project_aggrement' + tabIndex + '-tab'"
                  data-bs-toggle="pill"
                  [attr.data-bs-target]="'#project_aggrement' + tabIndex"
                  role="tab"
                  [attr.aria-controls]="'project_aggrement' + tabIndex"
                  aria-selected="false">
                  Agreements
                  <p class="f-10 ml-2 a-head-badge" *ngIf="agreementProjectsUsers?.length > 0">
                    {{ agreementProjectsUsers?.length }}
                  </p>
                </a>
              </li>
            </ul>
          </div>
          <div class="tab-content" id="pills-tabContent">
            <div
              class="tab-pane fade show active"
              [id]="'project_associate' + tabIndex"
              role="tabpanel"
              [attr.aria-labelledby]="'pills-project_associate' + tabIndex + '-tab'"
              tabindex="0">
              <div class="position-relative">
                <ng-container *ngIf="UserForm.controls['type'].value !== 'Company'">
                  <div
                    class="mb-3 mt-2"
                    *ngIf="userPermission.includes('contact.view') || userRole == 'master admin' || userRole == 'operations manager'">
                    <button type="submit" class="preview-btn" (click)="email_modal = true; getEmailTemplate()" [disabled]="isPrivate">
                      Send Email
                    </button>
                  </div>
                </ng-container>
                <ng-container *ngIf="accessRemmi">
                  <div class="row mb-3">
                    <div class="col-sm-9 pr-0">
                      <div class="form-group position-relative mb-0">
                        <label for="password">Password</label>
                        <input
                          [type]="showPassword ? 'text' : 'password'"
                          class="site-input"
                          [(ngModel)]="randomstring"
                          [readonly]="isPrivate"
                          autocomplete="new-password"
                          [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                        <i class="eye-icon" [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'" (click)="showHidePassword()"></i>
                      </div>
                    </div>
                    <div class="col-sm-3 mt-3">
                      <button class="preview-btn btn-sm f-12" (click)="generatePassword()">Generate Password</button>
                    </div>
                  </div>
                </ng-container>
                <div class="scrol_ asc_height" (scroll)="onScroll($event)" #scrollableElement>
                  <i class="pi pi-arrow-up" (click)="scrollToTop()" *ngIf="ascScrollTop > 50"></i>
                  <p-table
                    #dt1
                    *ngIf="AssociatedProjectsUsers"
                    [value]="AssociatedProjectsUsers"
                    (sortFunction)="onSortChange($event)"
                    [globalFilterFields]="['Project_Name']"
                    [(selection)]="AssociatedProjectSelection"
                    dataKey="_id">
                    <ng-template pTemplate="caption">
                      <div class="d-flex">
                        <div>
                          <div class="position-relative">
                            <input
                              type="text"
                              (input)="dt1.filterGlobal($event.target.value, 'contains')"
                              class="_input-icon"
                              placeholder="Search keyword" />
                            <i class="pi pi-search _search-icon"></i>
                          </div>
                        </div>
                        <div class="ml-auto mr-2 d-flex class-add-project">
                          <re-multiSelect
                            [options]="lmService?.ProjectList"
                            *ngIf="AssociatedProjectSelection.length < 1"
                            [(selectedOptions)]="AddNewProject"
                            optionLabel="Project_Name"
                            optionValue="_id"
                            class="multiselect"
                            class="msContainer mr-2 multiselect"
                            placeholder="Add project"></re-multiSelect>
                          <button
                            *ngIf="AddNewProject && AssociatedProjectSelection.length < 1"
                            class="_addNew cs-addNew"
                            (click)="AssociateUserToProject('add', AddNewProject)">
                            <i class="f-10 pi pi-plus f-14 _fw-600 text-primary"></i>
                          </button>
                          <button
                            (click)="AssociateUserToProject('remove', AssociatedProjectSelection)"
                            *ngIf="AssociatedProjectSelection.length > 0"
                            pButton
                            label="Delete"
                            class="p-button-outlined"
                            icon="pi pi-trash"></button>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                      <tr>
                        <th pSortableColumn="Project_Name">
                          <div class="d-flex align-items-center">
                            <p class="mr-2">Name</p>
                            <p-sortIcon field="Project_Name"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="createdon">
                          <div class="d-flex align-items-center">
                            <p class="mr-2">Create Date</p>
                            <p-sortIcon field="createdon"></p-sortIcon>
                          </div>
                        </th>
                        <th class="w-50">&nbsp;</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-project>
                      <tr class="compact-form">
                        <td>
                          <p>{{ project.Project_Name }}</p>
                        </td>
                        <td>
                          <p>{{ project.createdon | date: 'dd/MM/yy' }}</p>
                        </td>
                        <td class="text-center">
                          <button class="btn p-0">
                            <img [src]="common_images?.delete_icon" alt="delete" width="17px" (click)="AssociateUserToProject('remove', [project])" />
                          </button>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade show"
              [id]="'project_aggrement' + tabIndex"
              role="tabpanel"
              [attr.aria-labelledby]="'pills-project_aggrement' + tabIndex + '-tab'"
              tabindex="0">
              <div class="mt-3">
                <p-table
                  styleClass="pagination-dropdown"
                  scrollWidth="100%"
                  [value]="agreementProjectsUsers"
                  [rows]="sidePropertyRows"
                  [(selection)]="selectedRows">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="pl-0 w-40"></th>
                      <th class="project_th_1">Project</th>
                      <th class="project_th_2">Agreement Type</th>
                      <th class="project_th_2">Agreement Status</th>
                      <th class="project_th_1">Agreement Executed Date</th>
                      <th class="project_th_2">Created Date</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-agreed>
                    <tr (click)="openAgreement(agreed)" class="cursor-pointer">
                      <td></td>
                      <td>{{ agreed.project }}</td>
                      <td>{{ agreed.agreement_type }}</td>
                      <td>{{ agreed.agreement_status }}</td>
                      <td>{{ agreed.agreement_exe_date | date: 'dd/MM/yy' }}</td>
                      <td>{{ agreed.created_at | date: 'dd/MM/yy' }}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="7">No record found.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
              <p-dialog
                header="Update Agreement"
                [showHeader]="true"
                [(visible)]="agreement_dialog"
                [draggable]="false"
                [style]="{ width: '70vw' }"
                [modal]="true"
                [baseZIndex]="100000"
                [contentStyleClass]="'confirmDeleteViewDialog'">
                <ng-container *ngIf="agreement_dialog">
                  <app-project-agreement (is_agreement)="agreementhide($event)" [agree]="agreement_detail"></app-project-agreement>
                </ng-container>
              </p-dialog>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 7 && 'show active' }}"
          [id]="'cNotes' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-cNotes' + tabIndex + '-tab'"
          tabindex="0">
          <div *ngIf="insertedUserId && rightActiveIndex === 7" class="notes-mod mt-2">
            <app-notes
              [moduleId]="
                this.selectedContact || {
                  _id: this.insertedUserId,
                  property_address: UserForm.controls['full_name']?.value || UserForm.controls['company_name']?.value,
                }
              ">
            </app-notes>
          </div>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 8 && 'show active' }}"
          [id]="'cHistory' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-cHistory' + tabIndex + '-tab'"
          tabindex="0">
          <ng-container *ngIf="rightActiveIndex === 8 && (selectedContact?._id || insertedUserId)">
            <app-remmi-history [module]="'Contact'" [record_id]="selectedContact?._id || insertedUserId"></app-remmi-history>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<p-dialog
  [modal]="true"
  [style]="{ width: '70vw' }"
  [draggable]="false"
  [(visible)]="contactConflict"
  [autoZIndex]="true"
  position="center"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [transitionOptions]="'2ms'"
  appendTo="body">
  <ng-template pTemplate="header">
    <h5>Found similar contact, please confirm if you wish to create a new contact record.</h5>
  </ng-template>
  <div class="col-md-12">
    <div *ngIf="cContacts.length > 0" class="position-relative">
      <div class="scrol_similar" (scroll)="onContactScroll($event)" #contactScrollableElement>
        <i class="pi pi-arrow-up" (click)="scrollContactToTop()" *ngIf="contactScrollTop > 50"></i>
        <p-table id="customentitydatalist" [value]="cContacts" dataKey="_id" [rowHover]="false" [rows]="contactRows" [customSort]="true">
          <ng-template pTemplate="header">
            <tr>
              <th>First name</th>
              <th>Last name</th>
              <th>Email</th>
              <th>Type</th>
              <th>Contact type</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-contact>
            <tr>
              <td>{{ contact?.first_name }}</td>
              <td>{{ contact?.last_name }}</td>
              <td>{{ contact?.email }}</td>
              <td>{{ contact?.user_type }}</td>
              <td>{{ contact?.contact_type?.toString()?.split(',')?.join(', ') }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5">No record found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="mt-5">
      <p *ngIf="cContacts?.length > 0">
        {{ 'Records: ' + cContacts?.length }}
      </p>
    </div>
  </div>
  <div class="w-100 text-right">
    <button type="button" class="_cancel-btn mr-2" (click)="contactConflict = false">Cancel</button>
    <button type="button" class="_outline-btn" (click)="createContact(true)">Create New</button>
  </div>
</p-dialog>

<!-- tags -->
<p-dialog
  [styleClass]="'noHeader'"
  [showHeader]="false"
  [(visible)]="lmService.tag_manager"
  [style]="{ width: '350px' }"
  [position]="'right'"
  styleClass="tag-sidebar-manager">
  <div class="px-2 py-2">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h3 class="f-18">Tag Manager</h3>
      <div>
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-plus"
          pTooltip="New Tag"
          tooltipPosition="top"
          placeholder="Top"
          class="p-button-rounded p-button-secondary p-button-text mr-2"
          (click)="new_tag_popup = true"></button>
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-times"
          class="p-button-rounded p-button-secondary p-button-text"
          (click)="closeTagManger()"></button>
      </div>
    </div>

    <div class="mb-4">
      <div class="w-100 my-2 mr-3 position-relative with-right-icon mnw-230">
        <input class="site-input" type="text" #searchKeyword [(ngModel)]="keywordTags" placeholder="Search Tags" />
        <i class="f-14 pi pi-search cp search_i" *ngIf="!keywordTags"></i>
        <i class="pi pi-times cp f-14 search_i" *ngIf="keywordTags" (click)="noTagsFound = false; resetTagSearch()"></i>
      </div>
    </div>

    <div class="overflow-tags" *ngFor="let status of tagsData; let i = index">
      <p-accordion [multiple]="true">
        <ng-container *ngFor="let type of status?.types; let ind = index">
          <p-accordionTab [selected]="true" *ngIf="type._id !== 'createnew'">
            <p class="f-12 font-weight-bold">{{ type.name }}</p>
            <div cdkDropList #todoList="cdkDropList" [cdkDropListData]="type?.data" [cdkDropListConnectedTo]="[doneList]" class="pb-3 pt-2 pr-3">
              <div
                class="mr-2 mb-1 f-12 primary-chip cp p-chip d-inline-flex align-items-center pr-3"
                cdkDrag
                *ngFor="let item of type?.data"
                [cdkDragData]="item"
                (dblclick)="addTagInForm(0, item)"
                pTooltip="Double click to add"
                tooltipPosition="top"
                placeholder="Top">
                <div class="p-chip-text">{{ item?.tag_name }}</div>
              </div>
            </div>
          </p-accordionTab>
        </ng-container>
      </p-accordion>
    </div>
    <div *ngIf="noTagsFound">
      <p class="text-muted text-center py-1">No data found</p>
    </div>
  </div>
</p-dialog>

<!-- Tag Type -->
<p-dialog
  [(visible)]="newTagTypePopUp"
  [position]="'right'"
  [modal]="true"
  [style]="{ width: '300px' }"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'noHeader'"
  [showHeader]="false"
  styleClass="tag-sidebar-manager">
  <div>
    <div>
      <div class="mt-2">
        <label class="mb-1">Tag Type</label>
        <input type="text" placeholder="Tag type name" [(ngModel)]="tag_type" class="site-input" />
      </div>
    </div>

    <div class="flexCenterEnd mt-2">
      <button class="_cancel-btn mr-2" (click)="tag_type = null; newTagTypePopUp = false">Cancel</button>
      <button class="_outline-btn float-right" [class.disabled]="!tag_type" (click)="createTagType()">Add</button>
    </div>
  </div>
</p-dialog>

<!-- New tag -->
<p-dialog
  [(visible)]="new_tag_popup"
  [position]="'right'"
  [modal]="true"
  [style]="{ width: '300px' }"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'noHeader'"
  [showHeader]="false"
  styleClass="tag-sidebar-manager">
  <div class="p-2">
    <div>
      <div class="mt-2">
        <label class="mb-1 px-1 d-flex align-items-center justify-content-between"> Tag Type </label>
        <div class="dropdown-with-create-new" *ngIf="tagsData.length > 0">
          <ng-select
            class="tag-type"
            [items]="tagsData[0]?.types"
            [(ngModel)]="tag_type"
            bindLabel="name"
            bindValue="_id"
            placeholder="Select Tag Type"
            [showClear]="true"
            (change)="isNewTypeModel($event)">
            <ng-template ng-option-tmp let-item="item">
              <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
            </ng-template>
          </ng-select>
        </div>
        <small class="px-1 f-10">Select a module to see its tag types</small>
      </div>
      <div class="mt-2 chips-custom">
        <label class="mb-1 px-1 w-100 d-flex align-items-center justify-content-between">
          {{ userRole == 'master admin' || userRole == 'operations manager' ? 'Tags*' : 'Request New Tag*' }}
        </label>
        <div class="tag-chip">
          <p-chips #chipsRef [(ngModel)]="new_tag" placeholder="Add Multiple Tags" styleClass="w-100" (onAdd)="pushTagToArray($event)"></p-chips>
          <small class="px-1 f-10">Press enter after typing tag name</small>
        </div>
      </div>
    </div>
    <div class="flexCenterEnd mt-2">
      <button class="_cancel-btn mr-2" (click)="onCancelTagDialog()">Cancel</button>
      <button class="_outline-btn float-right" [class.disabled]="!new_tag?.length || loading" (click)="createTag()">
        {{ userRole == 'master admin' || userRole == 'operations manager' ? 'Add' : 'Request Tag' }}
      </button>
    </div>
  </div>
</p-dialog>

<div class="send_email_modal">
  <p-dialog
    [(visible)]="email_modal"
    [position]="'center'"
    [styleClass]="'noHeader'"
    [showHeader]="false"
    [style]="{ width: '750px', 'margin-top': '140px' }">
    <div class="headerIcon d-flex justify-content-end">
      <div class="crossiconStyle cursor-pointer event_poup_close_btn">
        <img [src]="common_images?.close_icon" class="p-1" width="30px" (click)="email_modal = false" />
      </div>
    </div>
    <div class="row ml-0 mr-0 mt-2">
      <div class="col-md-12">
        <div class="col-sm-12 mt-0">
          <label class="f-14 mb-1">To</label>
          <input type="text" name="stakeholder" disabled [(ngModel)]="emailTo" />
        </div>
        <div class="col-sm-12 mt-2">
          <label class="f-14 mb-1">From</label>
          <input type="text" name="stakeholder" disabled [(ngModel)]="emailFrom" />
        </div>
        <div class="col-sm-12 mt-2">
          <label class="f-14 mb-1">Select Template</label>
          <ng-select
            [items]="emailTemplates"
            [(ngModel)]="emailTempSelectedId"
            name="emailTemplate"
            bindLabel="name"
            bindValue="_id"
            [searchable]="true"
            (change)="getTemplateBody()"
            [clearable]="false"
            placeholder="Email Template">
            <ng-template ng-option-tmp let-item="item">
              <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-sm-12 mt-2">
          <label class="f-14 mb-1">Subject</label>
          <input type="text" name="subject" [(ngModel)]="emailSubject" />
        </div>
        <div class="col-sm-12 mt-2">
          <label class="f-14 mb-1">Body</label>
          <div class="w-100 _paragraph">
            <ckeditor [(ngModel)]="emailBody" class="email_modal_body" [editor]="Editor" [config]="ckEditorToolbar"> </ckeditor>
          </div>
        </div>
        <div class="d-flex align-items-center mt-3 mb-2 justify-content-end">
          <button class="_cancel-btn mr-3" (click)="email_modal = false">Cancel</button>
          <button (click)="sendEmail()" class="_outline-btn">Send</button>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
